import { render, staticRenderFns } from "./calculators.vue?vue&type=template&id=52533d7e&"
import script from "./calculators.vue?vue&type=script&lang=js&"
export * from "./calculators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports